//copy of ReactComponent.jsx for MyDataHelps
//to avoid including designer dependencies in the participant app
import React from 'react';
import { createRoot } from 'react-dom/client';
import Tabs from '../../components/MyDataHelps/Tabs/Tabs';
import ParticipantNavigation from '../../components/MyDataHelps/ParticipantNavigation/ParticipantNavigation';
import { TranslateContext } from "../MyDataHelps/TranslateContext";
import AuthenticationApp from '../../components/Authentication/Participant/App';

const getComponent = (component, props) => {
	if (component === 'Tabs') {
		return <Tabs {...props} />;
	}
	if (component === 'ParticipantNavigation') {
		return <ParticipantNavigation {...props} />;
	}
	if (component === 'Authentication') {
		return <AuthenticationApp {...props} />;
	}

	return null;
}

angular.module('ResearchKitApplicationModule').component('reactComponent', {
	template: '<div></div>',
	bindings: {
		'component': '@',
		'props': '='
	},
	controller: ['$element', '$scope', '$injector', '$translate', function ($element, $scope, $injector, $translate) {
		const $ctrl = this;

		const render = (component, props) => {
			$ctrl.root.render(
				<TranslateContext.Provider value={$translate}>
					{getComponent(component, props)}
				</TranslateContext.Provider>
			);
		}

		function renderComponent() {
			var props = $ctrl.props ? { ...$ctrl.props } : {};
			props.$scope = $scope;
			props.$injector = $injector;
			render($ctrl.component, props);
		}

		$ctrl.$onInit = () => {
			$ctrl.root = createRoot($element[0]);
			renderComponent();
			$scope.$watch('$ctrl.props', function () {
				renderComponent();
			}, true);
		}

		$ctrl.$onDestroy = () => $ctrl.root.unmount();
	}]
});